<div class="project-stage-selector">

    @if (projectName() != null) {
    <div class="project-name">
        {{ projectName() }}
    </div>
    } 

    @if(dropdownOptions().length > 0) {
        <div class="drop-down">
        <ev-dropdown
            class="small-screen"
            [height]="'33px'"
            [items]="dropdownOptions()"
            [selected]="+setSelectedStage()"
            [zIndex]="10"
            [variant]="'blue25'"
            (onSelected)="onSelect($event)"
            placeHolder="Prosjektoversikt">
        </ev-dropdown>
    </div>
    }
</div>
